import React, { Component } from 'react'
import { Skeleton, Space, Divider, Switch, Form, Radio } from 'antd';



export default class PlaceHolder extends Component {
    render() {
        return (
            <div>
                
            <div>
                
                <Skeleton.Input style={{ width: 1000 }} active />
                <br/><br/>
                <Skeleton.Input style={{ width: 1000 }} active />
                <br/><br/>
                <Skeleton.Input style={{ width: 1000 }} active />
                <br/><br/>
                <Skeleton.Input style={{ width: 1000 }} active />
                <br/><br/>
                
            </div>

            <div>
                
                <Skeleton.Input style={{ width: 1000 }} active />
                <br/><br/>
                <Skeleton.Input style={{ width: 1000 }} active />
                <br/><br/>
                <Skeleton.Input style={{ width: 1000 }} active />
                <br/><br/>
                <Skeleton.Input style={{ width: 400 }} active />
                <br/><br/>
                
            </div>
            <div>
                
                <Skeleton.Input style={{ width: 1000 }} active />
                <br/><br/>
                <Skeleton.Input style={{ width: 1000 }} active />
                <br/><br/>
                <Skeleton.Input style={{ width: 1000 }} active />
                <br/><br/>
                <Skeleton.Input style={{ width: 1000 }} active />
                <br/><br/>
                
            </div>
            <div>
                
                <Skeleton.Input style={{ width: 1000 }} active />
                <br/><br/>
                <Skeleton.Input style={{ width: 1000 }} active />
                <br/><br/>
                <Skeleton.Input style={{ width: 1000 }} active />
                <br/><br/>
                <Skeleton.Input style={{ width: 400 }} active />
                <br/><br/>
                
            </div>


            </div>
        )
    }
}
